import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '热门分类',
      links: categories.map((c) => ({ label: c.name, href: `/category/${c.slug}` })),
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', href: '/about' },
        { label: '联系方式', href: '/about' },
        { label: '投稿须知', href: '/about' },
      ],
    },
    {
      title: '法律信息',
      links: [
        { label: '免责声明', href: '/about' },
        { label: '隐私政策', href: '/about' },
        { label: '用户协议', href: '/about' },
      ],
    },
    {
      title: '关注我们',
      links: [
        { label: '微信公众号', href: '#' },
        { label: '新浪微博', href: '#' },
        { label: '抖音号', href: '#' },
      ],
    },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50 relative overflow-hidden">
      {/* Decorative world map outline */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
        <svg viewBox="0 0 1200 600" fill="none" className="w-full h-full">
          <path
            d="M100,300 Q150,250 200,280 T300,260 T400,290 T500,270 T600,300 T700,280 T800,310 T900,290 T1000,300 T1100,280"
            stroke="white"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </div>

      <div className="relative z-10 px-4 md:px-8 lg:px-12 py-12 md:py-16">
        {/* Top section */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left: brand + subscribe + slogan */}
          <div className="lg:w-1/3 flex flex-col gap-6">
            <Link to="/" className="flex items-center gap-1">
              <span className="font-heading text-xl md:text-2xl font-bold text-background-50 tracking-tight">
                {siteInfo.name}
              </span>
              <span className="w-2 h-2 rounded-full bg-primary-500 inline-block" />
            </Link>

            <div className="flex items-center gap-0">
              <input
                type="email"
                placeholder="订阅邮箱，不错过每一个大瓜"
                className="flex-1 bg-transparent border border-background-400/40 rounded-l-lg px-4 py-2.5 text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-primary-500"
              />
              <button className="w-11 h-11 flex items-center justify-center border border-l-0 border-background-400/40 rounded-r-lg hover:bg-primary-500 hover:border-primary-500 transition-colors">
                <i className="ri-notification-3-line text-background-50 w-5 h-5 flex items-center justify-center" />
              </button>
            </div>

            <p className="font-heading text-xl md:text-2xl text-background-50 leading-relaxed">
              全网吃瓜
              <br />
              不打烊
            </p>
          </div>

          {/* Right: link columns */}
          <div className="lg:w-2/3 grid grid-cols-2 md:grid-cols-4 gap-8">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">{col.title}</h4>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-background-300 hover:text-background-50 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom section */}
        <div className="mt-12 md:mt-16 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            © {currentYear} {siteInfo.name} 版权所有 | 本站内容仅供娱乐参考
          </p>

          <div className="flex items-center gap-3">
            {[
              { icon: 'ri-weibo-line', label: '微博' },
              { icon: 'ri-wechat-line', label: '微信' },
              { icon: 'ri-tiktok-line', label: '抖音' },
              { icon: 'ri-share-line', label: '分享' },
            ].map((social) => (
              <a
                key={social.label}
                href="#"
                rel="nofollow"
                aria-label={social.label}
                className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700/50 text-background-300 hover:text-background-50 hover:border-background-500 transition-all"
              >
                <i className={`${social.icon} w-4 h-4 flex items-center justify-center`} />
              </a>
            ))}
          </div>

          <Link to="/about" className="text-xs text-background-400 hover:text-background-50 transition-colors">
            隐私政策
          </Link>
        </div>
      </div>

      {/* JSON-LD Organization + WebSite */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'Organization',
              name: siteInfo.name,
              url: siteInfo.url,
              logo: siteInfo.logo,
              description: siteInfo.description,
              sameAs: [siteInfo.weibo, siteInfo.douyin, siteInfo.xiaohongshu].filter(Boolean),
            },
            {
              '@type': 'WebSite',
              name: siteInfo.name,
              url: siteInfo.url,
              potentialAction: {
                '@type': 'SearchAction',
                target: `${siteInfo.url}/search?q={search_term_string}`,
                'query-input': 'required name=search_term_string',
              },
            },
          ],
        })}
      </script>
    </footer>
  );
}